// Mock data for Dental Clinic Website

export const clinicData = {
  name: "Dr Shukla Dental Clinic",
  tagline: "Trusted Dental Care Since 2007",
  location: {
    area: "Nalasopara East",
    city: "Palghar",
    fullAddress: "First Floor, Laxman Nagar Building, Flat no 102/103/104, above Light Bill Payment Centre, opp. BJP Office, Galanagar, Nalasopara East, Maharashtra 401209"
  },
  contact: {
    phone: "070301 00500",
    whatsapp: "917030100500",
    email: "drshukladentalclinic@gmail.com"
  },
  workingHours: {
    weekdays: "Open 7 Days: 9:00 AM - 2:00 PM, 6:00 PM - 11:30 PM",
    sunday: "24/7 Emergency Services Available"
  },
  googleRating: {
    stars: 4.9,
    reviews: 859
  },
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d60411.60771982756!2d72.81309215!3d19.42230235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x0%3A0x0!2s19.4281472%2C72.8203264!3m2!1d19.4281472!2d72.8203264!4m5!1s0x3be7a9e1825a10d3%3A0x45c03f177a1f0d14!2sDR%20SHUKLA%20DENTAL%20CLINIC%2C%20First%20Floor%2C%20Laxman%20Nagar%20Building%2C%20Flat%20no%20102%2F103%2F104%2C%20above%20Light%20Bill%20Payment%20Centre%2C%20opp.%20BJP%20Office%2C%20Galanagar%2C%20Nalasopara%20East%2C%20Maharashtra%20401209!3m2!1d19.4164445!2d72.8276892!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
};

export const doctorData = {
  name: "Dr. Yogendra R. Shukla",
  qualifications: "BDS",
  registration: "Maharashtra State Dental Council (Reg. No: A-14237)",
  experience: "18+ years",
  since: "Registered Practitioner Since 2007",
  about: "Dr. Yogendra R. Shukla is a highly experienced dental surgeon with 18+ years of clinical experience in general, cosmetic, and implant dentistry. He completed his Bachelor of Dental Surgery (BDS) from Maharashtra University of Health Sciences, Nashik, and has been a registered practitioner with the Maharashtra State Dental Council (Reg. No: A-14237) since 2007. His practice is trusted by hundreds of patients and holds an exceptional 4.9 Google Rating from 800+ reviews. Dr. Shukla is known for ethical treatment planning, painless procedures, and long-term patient relationships built on transparency and trust.",
  expertise: [
    "General Dentistry",
    "Cosmetic Dentistry",
    "Implant Dentistry",
    "Basal Implantology"
  ],
  advancedTraining: [
    "Hands-On Surgical Workshop in Basal Implantology",
    "Advanced Esthetic Dentistry Certification",
    "International Implantology & Microsurgery Symposium (Boston Collaboration)",
    "Continuing Dental Education in CT & MRI Diagnostics"
  ],
  knownFor: [
    "Ethical treatment planning",
    "Painless procedures",
    "Transparency and trust",
    "24/7 emergency services"
  ],
  image: "https://customer-assets.emergentagent.com/job_19e5deb8-7455-448c-92eb-cc63265412b4/artifacts/ac3r58s8_ChatGPT%20Image%20Feb%2022%2C%202026%2C%2003_45_53%20AM.png"
};

export const servicesData = [
  {
    id: 1,
    title: "Root Canal Treatment",
    description: "Endodontic therapy to treat infected tooth pulp, preserving the natural tooth structure and restoring function."
  },
  {
    id: 2,
    title: "Dental Implants",
    description: "Permanent tooth replacement solution using titanium posts surgically placed in the jawbone to support prosthetic teeth."
  },
  {
    id: 3,
    title: "Teeth Cleaning",
    description: "Professional oral prophylaxis to remove plaque, tartar, and stains, maintaining gum health and preventing periodontal disease."
  },
  {
    id: 4,
    title: "Cosmetic Dentistry",
    description: "Aesthetic dental procedures including teeth whitening, veneers, and smile makeovers to enhance dental appearance."
  },
  {
    id: 5,
    title: "Basal Implants",
    description: "Advanced single-visit implant surgery technique for immediate tooth replacement, suitable for patients with bone loss."
  },
  {
    id: 6,
    title: "Tooth Extraction",
    description: "Safe removal of damaged or problematic teeth when preservation is not viable, performed with appropriate anesthesia."
  }
];

export const whyChooseUsData = [
  {
    title: "18+ Years of Experience",
    description: "Trusted dental surgeon with extensive clinical experience since 2007"
  },
  {
    title: "Open 365 Days",
    description: "No holidays - open 7 days a week including Sundays and festivals"
  },
  {
    title: "24/7 Emergency Services",
    description: "Round-the-clock emergency dental care available any time you need it"
  },
  {
    title: "4.9 Google Rating",
    description: "Exceptional rating from 800+ verified patient reviews"
  },
  {
    title: "Ethical Treatment",
    description: "Transparent treatment planning with focus on patient education and long-term care"
  },
  {
    title: "Advanced Training",
    description: "International certifications in implantology, cosmetic dentistry, and microsurgery"
  }
];

export const reviewsData = [
  {
    id: 1,
    name: "Brijesh Mourya",
    reviewCount: 1,
    date: "a week ago",
    rating: 5,
    review: "I had my friend's tooth extracted using the laser method at Dr. Shukla's clinic, and it was completely painless. I also really enjoyed the professionalism and care shown during the procedure.",
    hasResponse: true,
    response: "Thank you for your kind words!"
  },
  {
    id: 2,
    name: "Sameer Ahmad",
    reviewCount: 2,
    date: "5 months ago",
    rating: 5,
    review: "I had an amazing experience with this doctor. I was nervous about getting my tooth extracted, but the doctor's friendly and caring nature made me feel completely at ease. The extraction was done smoothly without any complications.",
    hasResponse: false
  },
  {
    id: 3,
    name: "Naina Sonar",
    reviewCount: 3,
    date: "3 weeks ago",
    rating: 5,
    review: "I have removed my teeth from Dr. Shukla's clinic by using laser method and it was completely done without any pain. I must have to say for dental treatment this clinic is completely excellent. Thank you Dr. Shukla ji.",
    hasResponse: true,
    response: "Thank you for trusting us with your dental care!"
  },
  {
    id: 4,
    name: "Kousthubh Lele",
    reviewCount: 12,
    date: "3 months ago",
    rating: 5,
    review: "Fantastic service, best medical practitioner, affordable.",
    hasResponse: false
  },
  {
    id: 5,
    name: "Ravi Shankar",
    reviewCount: 5,
    date: "a month ago",
    rating: 5,
    review: "Non pain and good doctor Mr Shukla ji, treatment is giving best in Nalasopara.",
    hasResponse: false
  },
  {
    id: 6,
    name: "Ayush Singh",
    reviewCount: 8,
    date: "4 months ago",
    rating: 5,
    review: "A very good doctor and also explained the procedure very well. The fees is also good and reasonable.",
    hasResponse: false
  }
];

export const galleryData = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_smile-care-pro-1/artifacts/3i2fuu5o_Screenshot%202026-02-17%20134347.png",
    alt: "Modern dental chair and equipment"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_smile-care-pro-1/artifacts/4qsrvkel_Screenshot%202026-02-17%20135018.png",
    alt: "Dental services available"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_smile-care-pro-1/artifacts/9oebo0ph_Screenshot%202026-02-17%20135448.png",
    alt: "Dr. Shukla treating patient"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_smile-care-pro-1/artifacts/xsgkpqd7_Screenshot%202026-02-17%20140140.png",
    alt: "Clinic reception and waiting area"
  }
];

export const faqData = [
  {
    id: 1,
    question: "Are you open on Sundays and holidays?",
    answer: "Yes, Dr. Shukla Dental Clinic is open 365 days a year, including Sundays and all festivals. We also provide 24/7 emergency dental services for urgent cases."
  },
  {
    id: 2,
    question: "Is root canal treatment painful?",
    answer: "Root canal treatment at our clinic is completely painless. We use modern anesthesia techniques and Dr. Shukla's expertise ensures a comfortable experience. The procedure is comparable to getting a routine filling."
  },
  {
    id: 3,
    question: "What are basal implants and how are they different?",
    answer: "Basal implants are advanced single-visit implant surgery technique where teeth can be replaced immediately, often in just one day. They are especially suitable for patients with bone loss and don't require lengthy healing periods like traditional implants."
  },
  {
    id: 4,
    question: "Where is the clinic located in Nallasopara?",
    answer: "We are located on the First Floor of Laxman Nagar Building (Flat no 102/103/104), above Light Bill Payment Centre, opposite BJP Office in Galanagar, Nalasopara East, Maharashtra 401209."
  },
  {
    id: 5,
    question: "How much experience does Dr. Shukla have?",
    answer: "Dr. Yogendra R. Shukla has 18+ years of clinical experience in general, cosmetic, and implant dentistry. He has been a registered practitioner with Maharashtra State Dental Council since 2007 and holds advanced international certifications."
  },
  {
    id: 6,
    question: "What should I do in a dental emergency?",
    answer: "Call us immediately at 070301 00500. Dr. Shukla provides 24/7 emergency dental services and will attend to urgent cases at any time, including nights and holidays."
  },
  {
    id: 7,
    question: "How can I book an appointment?",
    answer: "You can call us at 070301 00500 or WhatsApp the same number. We also accept walk-in patients. For emergencies, we provide immediate attention any time of the day."
  }
];
